'use client';

import TaskFlow from './TaskFlow';
import styles from './index.less';

interface ITask {
  mindId: string;
  sessionId: string;
}

const Task = (props: ITask): React.ReactNode => {
  const { mindId, sessionId } = props;

  return (
    <div className={styles.container} id="TaskFlowContainer">
      {/* 20240218 删除了chat-list里的timer shortcut */}
      <div className={styles.contentContainer}>
        <TaskFlow mindId={mindId} sessionId={sessionId} />
      </div>
    </div>
  );
};

export default Task;
